import React from 'react';
import { FiTrendingUp, FiTrendingDown, FiAlertCircle } from 'react-icons/fi';
import styles from './MetricCard.module.css';
import LoadingIndicator from '../loading-indicator/LoadingIndicator';

const MetricCard = ({ 
  title, 
  value, 
  subtitle, 
  trend, 
  icon, 
  format = 'number',
  loading = false,
  warning = false,
  style
}) => {
  
  const formatValue = () => {
    if (loading) return '...';
    
    switch(format) {
      case 'percentage':
        return `${value}%`;
      case 'decimal':
        return Number(value).toFixed(1);
      case 'time':
        // Format milliseconds to seconds
        return `${(value / 1000).toFixed(2)}s`;
      case 'duration':
        // Format seconds to minutes:seconds
        const minutes = Math.floor(value / 60);
        const seconds = value % 60;
        return `${minutes}m ${seconds}s`;
      case 'number':
      default:
        // Format large numbers with commas
        return Number(value).toLocaleString();
    }
  };

  const getTrendIcon = () => {
    if (trend === null || trend === undefined) return null;
    if (trend === 0) return null; // No icon for 0% but still show the value
    return trend > 0 ? <FiTrendingUp /> : <FiTrendingDown />;
  };

  const getTrendClass = () => {
    if (trend === null || trend === undefined || trend === 0) return '';
    return trend > 0 ? styles['trend-positive'] : styles['trend-negative'];
  };

  return (
    <div className={`${styles['metric-card']} ${warning ? styles['warning'] : ''}`} style={style}>
      <div className={styles['card-header']}>
        <div className={styles['card-icon']}>
          {icon}
        </div>
        {warning && (
          <div className={styles['warning-icon']}>
            <FiAlertCircle />
          </div>
        )}
      </div>
      
      <div className={styles['card-content']}>
        <h3 className={styles['card-title']}>{title}</h3>
        
        {loading ? (
          <div className={styles['loading-container']}>
            <LoadingIndicator asMessage={false} />
          </div>
        ) : (
          <>
            <div className={styles['card-value']}>
              {formatValue()}
            </div>
            
            <div className={styles['card-footer']}>
              {subtitle && (
                <span className={styles['card-subtitle']}>{subtitle}</span>
              )}
              {trend !== undefined && trend !== null && (
                <span className={`${styles['card-trend']} ${getTrendClass()}`}>
                  {getTrendIcon()}
                  <span>{Math.abs(trend)}%</span>
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MetricCard;

